import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import Table from '@/common/components/Table'
import TextField from '@/common/components/TextField'
import { usePrinterMachines } from '@/common/hooks/queries/usePrinterMachines'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { PrinterMachineData, PrinterMachineTableItem } from '@/common/types/printerMachine.type'
import { printerMachinesColumns } from '@/features/printerMachines/constants/printerMachinesColumns.constant'
import { PrinterMachinesTransformer } from '@/features/printerMachines/services/printerMachinesTransformer'
import { PrinterIcon, SearchIcon } from 'lucide-react'

const List = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [search, setSearch] = useDebounce(filterParams.search || '')

  const {
    data: printerMachines,
    meta,
    isPending: isPendingPrinterMachines,
    error: printerMachinesError = {} as any,
    refetch: refetchPrinterMachines,
  } = usePrinterMachines({
    filters: {
      search: search,
      page: filterParams.page,
    },
    mapper: Mapper.mapWithTransformer<PrinterMachineData[], PrinterMachineTableItem[]>({
      transformer: PrinterMachinesTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      <ListHeader Icon={<PrinterIcon className="size-10" strokeWidth={1} />} title="Impressoras de cartão" />

      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={printerMachinesError?.status}
        refetchFunction={refetchPrinterMachines}
      >
        <div className="flex flex-col gap-6">
          <TextField
            LeftIcon={<SearchIcon />}
            placeholder="Pesquisar"
            className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
            onChange={(e) => {
              setSearch((e.target as HTMLInputElement).value)
              setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }))
            }}
            value={filterParams.search}
          />

          <Table
            className="max-h-[calc(100vh-192px)]"
            columns={printerMachinesColumns}
            isLoadingData={isPendingPrinterMachines}
            rows={printerMachines || []}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            rowEmptyValue="--"
            page={filterParams.page ? Number(filterParams.page) : 1}
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}

export default List
